import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import client from "api/WookAxios";
import { naver, kakao, google, authorize } from "auth/DeprecatedOAuth";
import naverOAuth from "images/naverLogoButton.png";
import kakaoOAuth from "images/kakao_oauth_large.png";
import googleOAuth from "images/google_oauth.svg";
import { AiOutlineClose } from "react-icons/ai";
import { Navigate, useNavigate } from "react-router-dom";
import useAuthenticate from "auth/useAuth";
import { flushSync, useFormState } from "react-dom";
import UserContext from "user/UserContext";
import Button from "components/common/Button";
import consentList from "auth/register/consentList";
import { parseErrors, parseFieldError } from "lib/errors/parse";
import log from "loglevel";
import { AUTH_STATUS } from "constants/auth";
import { toast } from "sonner";
import { ERROR_MESSAGES } from "constants/errors";
import { toastAlert, toastError } from "lib/toast";
import { FieldError } from "components/common/FieldError";
import zxcvbn from 'zxcvbn';
import { Checker, Indicator, CheckerBox } from "components/common/Mark";
import { PASSWORD_STRENGTH } from "constants/auth";
import { IS_PROD } from "config/env";
import { normalizeEmail, normalizeMobile } from "utils/normalize";
import { PasswordInput } from "components/common/PasswordInput";

const Modal = styled.div`
  // background: lavender;
  box-sizing: border-box;
  position: relative;
  top: 20px;
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  align-items: center;
  border-radius: 20px;
  width: 350px;
  height: 6570px;
  margin: 0 auto;
  background: #fafbfa;
  background: white;
  opacity: 1;
`;

const ProfileContainer = styled.div`
  // background: lavender;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 20px;
  border: solid lavender 2px;
  width: 320px;
`;

const PasswordContainer = styled.div`
  // background: lavender;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 20px;
  border: solid PaleTurquoise 2px;
  width: 320px;
  margin-top: 10px;
`;

const Title = styled.div`
  // height: 40px;
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 35px;
  font-weight: 500;
  color: #464646;
  padding-top: 10px;
  // padding-left: 10px;
  display: flex;
  justify-content: center;
`;

const StyledForm = styled.form`
  width: 280px;
  padding: 15px 0;
  // background: red;
`;

const StyledInput = styled.input`
  width: 98.5%;
  height: 30px;
  box-sizing: border;
  border-radius: 4px;
  border: none;
  margin-bottom: 0px;
  background: #eeeeee;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;

  &::placeholder {
    color: black;
  }

  &:focus {
    color: black;
  }
`;

const StyledPasswordInput = styled(PasswordInput)`
  width: 98.5%;
`;

const PasswordBox = styled.div`
`;

const ButtonContainer = styled.div`
// background: red;
  width: 98.5%;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

const StyledSubmit = styled.input`
  width: 70%;
  height: 100%;
  border-radius: 4px;
  border: none;
  background: pink;
  // margin-bottom: 20px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  font-weight: 700;
  color: #363636;
  cursor: pointer;
`;

const StyledPasswordSubmit = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border: none;
  background: pink;
  // margin-bottom: 20px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  font-weight: 700;
  color: #363636;
  cursor: pointer;
`;

const ResignButton = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 5px;
  border-radius: 4px;
  width: 60px;
  height: 100%;
  background: gray;
  color: white;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  cursor: pointer;
`;

const Topic = styled.label`
  // background: lightpink;
  display: inline-block;
  margin-top: 8px;
  color: ${props => props.$disabled ? 'gray' : 'blue'};
  font-size: 15px;
`;

const Item = styled.div`
  // background: lightgray;
  width: 98.5%;
  height: 35px;
  box-sizing: border;
  border-radius: 4px;
  border: none;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;

  &::placeholder {
    color: black;
  }

  &:focus {
    color: black;
  }
`;

const Label = styled.label`
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // width: 100%;
  // padding-right: 20px;
  margin-left: 5px;
  // font-size: 15px;
  // background: red;
`;

export const MyPage = () => {
  const { user, setUser, setAuthStatus } = useContext(UserContext);
  const [oauthSession, setOAuthSession] = useState(null);
  const [checked, setChecked] = useState(user.allow_notice);
  const [fieldError, setFieldError] = useState({});
  const [newPassword, setNewPassword] = useState('');
  const newPasswordScore = zxcvbn(newPassword).score;
  const newPasswordStrength = PASSWORD_STRENGTH[newPasswordScore];
  const newPasswordState = ({
    length: newPassword.length >= 8,
    alpha: /[A-Za-z]/.test(newPassword),
    digit: /[0-9]/.test(newPassword),
    special: /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/.test(newPassword),
  });
  
  const navigate = useNavigate();
  
  useEffect(() => {
    const getOAuthSessionInfo = async () => {
      try {
        const response = await client.oauthSession();
        log.debug('OAUTH_SESSION_INFO', response);
        setOAuthSession({ provider: response.data.provider });
      } catch(e) {
        log.debug('OAUTH_SESSION_INFO_FAILED', e);
        const errors = parseErrors(e.response);
        toast.error(errors[0].message);
        if (errors[0].code === 'OAUTH_SESSION_INVALID') {
          navigate('/');
          return
        }
      }
    };
    getOAuthSessionInfo();
  }, []);
  
  const validateProfileChange = (email, mobile) => {
    const errors = {};
    
    const normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) {
      errors.email = '잘못된 형식의 이메일 입니다.';
    }

    const normalizedMobile = normalizeMobile(mobile);
    if (!normalizedMobile) {
      errors.mobile = '올바르지 않은 전화번호 입니다.';
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleAllowNotice = () => {
    setChecked(!checked);
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    
    const name = e.target.name.value;
    const email = e.target.email.value;
    const mobile = e.target.mobile.value;
    const allow_notice = e.target.allow_notice.checked;
    
    const errors = validateProfileChange(email, mobile);
    if (errors) {
      setFieldError(errors);
      return;
    }
    
    const profileData = {
      name: name,
      email: email,
      mobile: mobile,
      allow_notice: allow_notice,
    };

    try {
      const response = await client.updateMe(profileData);
      log.debug('UPATE_ME_SUCCESS', response);
      setFieldError({});
      setUser(response.data);
      toast('회원 정보가 수정 되었습니다.');
    } catch (e) {
      log.debug('UPDATE_ME_FAILED', e);
      const errors = parseErrors(e.response);
      toastError(errors[0].message);
      setFieldError(parseFieldError(e.response));
    }
  };

  const handleResign = async () => {
    const yes = window.confirm('정말로 탈퇴하시겠습니까?');
    if (!yes) return;

    try {
      const response = await client.resign();
      log.debug('AUTH_RESIGN_SUCCESS', response);
      toast.success('회원탈퇴가 완료 되었습니다.');
    } catch(e) {
      log.debug('AUTH_RESIGN_FAILED', e.response);
    } finally {
      window.__skipProtectedMsg = true;
      setAuthStatus(AUTH_STATUS.UNAUTHENTICATED);
      setUser(null);
    }
  };

  const onChangeNewPassword = (e) => {
    setNewPassword(e.target.value);
    setFieldError({});
  };

  const validatePasswordChange = (password, newPassword2) => {
    const errors = {};

    if (!password) {
      errors.password = '현재 비밀번호를 입력하세요';
      return errors;
    }

    if (!newPassword) {
      errors.new_password = '필수 항목입니다.';
      return errors;
    } 

    const validNewPassword = Object.values(newPasswordState).every(Boolean);
    if (!validNewPassword) {
      errors.new_password = '비밀번호 조건을 확인해 주세요.';
      return errors;
    }

    if (newPassword !== newPassword2) {
      errors.new_password2 = '비밀번호가 일치하지 않습니다.';
      return errors;
    }

    return null;
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    const password = e.target.password.value;
    const newPassword2 = e.target.new_password2.value;
    
    const wantsPasswordChange = password || newPassword || newPassword2;
    if (!wantsPasswordChange) return;
    
    const errors = validatePasswordChange(password, newPassword2);
    if (IS_PROD && Object.keys(errors).length > 0) {
      setFieldError(errors);
      return;
    }
    
    const passwordData = {
      password: password,
      new_password: newPassword,
      new_password2: newPassword2,
    };

    try {
      const response = await client.changePassword(passwordData);
      log.debug('CHANGE_PASSWORD_SUCCESS', response);
      toast.success('비밀번호가 수정되었습니다.');
    } catch(e) {
      log.debug('CHANGE_PASSWORD_FAILED', e);
      setFieldError(parseFieldError(e.response));
      return;
    }
  };

  return (
    <div className="MyPage">
      <Modal>
        <Title>회원정보 관리</Title>
        <ProfileContainer>
          <StyledForm onSubmit={handleProfileSubmit}>
            {oauthSession?.provider ? 
              (
                <>
                  <Topic $disabled>ID</Topic>
                  <StyledInput 
                    name="username" 
                    value={`${oauthSession?.provider} 계정으로 가입했습니다.`} 
                    disabled 
                  />
                  <FieldError message={fieldError.username} />
                </>
              )
              :
              (
              <>
                <Topic $disabled>ID</Topic>
                <StyledInput name="username" value={user.username} disabled />
                <FieldError message={fieldError.username} />
              </>
              )
            }
            
            <Topic>이름</Topic>
            <StyledInput name="name" defaultValue={user.name} />
            <FieldError message={fieldError.name} />

            <Topic>이메일</Topic>
            <StyledInput name="email" defaultValue={user.email} />
            <FieldError message={fieldError.email} />

            <Topic>전화번호</Topic>
            <StyledInput name="mobile" defaultValue={user.mobile} />
            <FieldError message={fieldError.mobile} />
            
            <Topic>알림 설정</Topic>
            <Item>
              <input 
                type="checkbox" 
                name="allow_notice" 
                onChange={handleAllowNotice} 
                checked={checked}
                // defaultChecked={user.allow_notice}
              />
              <Label>이메일, Push, SMS 알림 허용</Label>
            </Item>

            <ButtonContainer>
              <StyledSubmit type="submit" value="항목수정" />
              <ResignButton onClick={handleResign}>회원탈퇴</ResignButton>
            </ButtonContainer>
          </StyledForm>
        </ProfileContainer>

        {!oauthSession?.provider && (
          <PasswordContainer>
            <StyledForm onSubmit={handlePasswordSubmit}>
                <PasswordBox>
                  <Topic $disabled={oauthSession?.provider}>현재 비밀번호</Topic>
                  <StyledPasswordInput name="password" disabled={oauthSession?.provider} />
                  <FieldError message={fieldError.password} />
                  <Topic $disabled={oauthSession?.provider}>새 비밀번호</Topic>
                  {newPassword.length > 0 && (
                    <Indicator score={newPasswordScore}>강도: {newPasswordStrength}</Indicator>
                  )}
                  <StyledPasswordInput
                    name="new_password"
                    disabled={oauthSession?.provider}
                    onChange={onChangeNewPassword}
                  />
                  {newPassword.length > 0 && (
                    <div>
                      <CheckerBox>
                        조건
                        <Checker ok={newPasswordState.length}>8자이상</Checker>
                        <Checker ok={newPasswordState.alpha}>영문포함</Checker>
                        <Checker ok={newPasswordState.digit}>숫자포함</Checker>
                        <Checker ok={newPasswordState.special}>특수문자포함</Checker>
                      </CheckerBox>
                    </div>
                  )}
                  <FieldError message={fieldError.new_password} />                  
                  <Topic $disabled={oauthSession?.provider}>새 비밀번호 확인</Topic>
                  <StyledPasswordInput name="new_password2" disabled={oauthSession?.provider} />                  
                  <FieldError message={fieldError.new_password2} />
                </PasswordBox>

              <ButtonContainer>
                <StyledPasswordSubmit type="submit" value="비밀번호수정" />
              </ButtonContainer>

            </StyledForm>         
          </PasswordContainer>
        )}
      </Modal>
    </div>
  );
};